/**
 * @generated SignedSource<<86d903b1e8367fb3c6d855cd41b08d20>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplatesDataRef$data = {
  readonly id: string;
  readonly intentTemplates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"intentTemplate_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar">;
      } | null | undefined;
    }> | null | undefined;
    readonly hasDiscoveredTemplates?: boolean | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"lastUpdatedTimestamp_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar">;
  } | null | undefined;
  readonly " $fragmentType": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplatesDataRef";
};
export type content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplatesDataRef$key = {
  readonly " $data"?: content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplatesDataRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplatesDataRef">;
};

import content_servicedeskSettingsVirtualAgentCreateIntents_PaginatedIntentTemplatesQuery_graphql from './content_servicedeskSettingsVirtualAgentCreateIntents_PaginatedIntentTemplatesQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "intentTemplates"
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDiscoveredTemplatesTimestampEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "isGateIntentTemplatesBehindAiToggleEnabled"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": content_servicedeskSettingsVirtualAgentCreateIntents_PaginatedIntentTemplatesQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplatesDataRef",
  "selections": [
    {
      "alias": "intentTemplates",
      "concreteType": "VirtualAgentIntentTemplatesConnection",
      "kind": "LinkedField",
      "name": "__content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplates_connection",
      "plural": false,
      "selections": [
        {
          "condition": "isGateIntentTemplatesBehindAiToggleEnabled",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "hasDiscoveredTemplates"
            }
          ]
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "isDiscoveredTemplatesTimestampEnabled",
              "variableName": "isDiscoveredTemplatesTimestampEnabled"
            }
          ],
          "kind": "FragmentSpread",
          "name": "lastUpdatedTimestamp_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar"
        },
        {
          "concreteType": "VirtualAgentIntentTemplateEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "VirtualAgentIntentTemplate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "FragmentSpread",
                  "name": "intentTemplate_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar"
                },
                {
                  "kind": "ScalarField",
                  "name": "__typename"
                }
              ]
            },
            {
              "kind": "ScalarField",
              "name": "cursor"
            }
          ]
        },
        {
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "endCursor"
            },
            {
              "kind": "ScalarField",
              "name": "hasNextPage"
            }
          ]
        }
      ]
    },
    (v1/*: any*/)
  ],
  "type": "JiraProject"
};
})();

(node as any).hash = "915031d521ef1e657922ee1b44339a0d";

export default node;
